module.exports = __webpack_public_path__ + "static/spring-active-b4dc807577df39bd4c5b36eae481693e.png";